<ng-container [formGroup]="parent">
  <ng-container formGroupName="customerAddress">
    <h3 class="mb-2">Bill To</h3>
    <div
      class="form-group has-float-label mb-2"
      (click)="redirectToClientSummary()">
      <label class="form-label">Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control has-link"
        formControlName="name" />
    </div>
    <div class="form-group has-float-label mb-2">
      <label class="form-label">Attention</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="billingAttentionD365" />
    </div>
    <div class="form-group has-float-label mb-2">
      <label class="form-label">Location</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="billingLocationD365" />
    </div>
    <div class="form-group has-float-label mb-2">
      <label class="form-label">Address</label>
      <textarea
        pInputText
        jniAutoCompleteBlocker
        class="form-control address"
        formControlName="address"></textarea>
    </div>
    <div class="form-group has-float-label mb-2">
      <label class="form-label">Telephone</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        formControlName="telephone" />
    </div>
  </ng-container>
</ng-container>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details [clientIdFromModal]="clientId"> </jni-client-details>
  </div>
</jni-modal-stacker>
